export function getFileNameWithOutHash(originalFileName: string): string {
  if (!originalFileName || originalFileName === 'null') {
    return ''
  }

  const firstTrace = originalFileName.indexOf('-')
  if (firstTrace === -1) {
    return originalFileName
  }

  return originalFileName.slice(firstTrace + 1, originalFileName.length)
}
